import { NgClass, SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { DfUiModule } from '@df/ui/df-ui.module';
import { HideUpComponent } from '@df/ui/hide-up/hide-up.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { EDITORIAL_FAQ_CONFIG } from './editorial-faq.config';
import { NPageEditorialFaq } from './editorial-faq.interface';

let uid = 0;

@Component({
    selector: 'page-component-editorial-faq',
    templateUrl: './editorial-faq.html',
    standalone: true,
    imports: [
        DfUiModule,
        HideUpComponent,
        HrefComponent,
        ICmsClientModule,
        ImageModule,
        NgClass,
        SlicePipe,
        ToggleModule,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentEditorialFaqComponent>(EDITORIAL_FAQ_CONFIG)
export class PageComponentEditorialFaqComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component!: NPageEditorialFaq.IComponentData;

    private readonly _uid = `editorialFaq_${++uid}`; // unique id for toggle_uid

    protected toggleService = inject(ToggleService);

    readonly toggleGroup = 'editorial-faq-group' + this.uid;

    readonly EVariant = NPageEditorialFaq.EVariant;

    displayLimit = NPageEditorialFaq.QUESTIONS_LIMIT;

    override ngOnInit() {
        super.ngOnInit();
        if (!this.component.viewMore) {
            this.displayLimit = this.allQuestions.length;
        }
    }

    toggleLimit() {
        if (this.displayLimit === NPageEditorialFaq.QUESTIONS_LIMIT) {
            this.displayLimit = this.allQuestions.length;
        } else {
            this.displayLimit = NPageEditorialFaq.QUESTIONS_LIMIT;
        }
        this.detectChanges();
    }

    get allQuestions() {
        const questions = [];
        this.component.columns.map(column => {
            if (column.variant === NPageEditorialFaq.EVariant.tabs) {
                return questions.push(...column.questions);
            }
        });
        return questions;
    }

    get uid(): string {
        return this._uid;
    }
}
